import { logError } from '~/utils/log-error'

export const copyToClipboard = async (text: string) => {
  try {
    if (!navigator?.clipboard) return
    await navigator.clipboard.writeText(text)
  } catch (e) {
    logError(e)
  }
}
